/**
 * How long the signup preamble (`checkReferral`) and the account-creation
 * request may hang before the visitor is told something.
 *
 * MEASURED DEFECT (web-stg, bundle main.09dd1743.js, 2026-09-30 --
 * stgqa-0927-P0-kelly-gate-a-auth-onboarding-discover-r093011): a fresh
 * signup's `checkReferral` call took 7.7s and the following `POST
 * /api/v1/signup/` took 12.3s under ordinary staging load, both issued via
 * bare `axios` with NO `timeout` configured. The Sign Up button (`isLoading
 * = userLogin.isLoading || isSigningUp`) sat disabled showing its spinner for
 * the entire wait with ZERO toast and ZERO way to retry -- the same
 * unbounded-wait shape already fixed for /login (see ./loginTimeout.js) and
 * for /forgot-password, just never ported to signup.
 *
 * A request that never settles is worse here than anywhere else in the app:
 * it is a brand-new, non-technical visitor's very first interaction, and a
 * silently-stuck "Sign Up" button reads as "this site is broken."
 *
 * 20s matches LOGIN_TIMEOUT_MS: staging p99 for these endpoints is well
 * under half that, so this only ever fires on a genuine hang.
 */
export const SIGNUP_TIMEOUT_MS = 20000;
